import classNames from 'classnames';
import React from 'react'
import parser from 'html-react-parser'
import {
    section,
    panelSpaceTop,
    panelSpaceBottom,

} from './ContentCards3.module.css'
export default function ContentCards3({data}) {
    const {contentCards3ButtonText, contentCards3Subtitle, contentCards3ButtonLink, contentCards3Title, contentCards3Cards, contentBlocks3BlocksColor, contentCards3TopPadding, contentCards3BottomPadding, contentCards3ButtonExternalLink} = data
    return (
        <div className={`leading-program-detail-wrap global-csa-boxes ${contentCards3TopPadding ? panelSpaceTop: 'pt-0'} ${contentCards3BottomPadding ? panelSpaceBottom: 'pb-0'} `}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-8 offset-md-2 offset-sm-0 text-center mb-3'>
                        <h2 className='heading-level-2 blue-color'>{contentCards3Title && parser(contentCards3Title)}</h2>
                        {contentCards3Subtitle && <p>{parser(contentCards3Subtitle)}</p>}
                    </div>
                </div>
                <div className='row'>
                    {contentCards3Cards?.map((block, i) => (
                        <div className='col-md-4 program-col' key={i}>
                            <div className={`program-dt-bx ${contentBlocks3BlocksColor==='blue' ? 'light-blue-col' : 'd-green-bx'} `}>
                                <div className={`heading-level-4-b  ${contentBlocks3BlocksColor==='blue' ? 'blue-color' : 'black-color'}`}>
                                    {block.contentCards3CardTitle && parser(block.contentCards3CardTitle)}
                                </div>
                                <p>{block.contentCards3CardText && parser(block.contentCards3CardText)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

